import { supabase } from "../supabase/client";
import { searchAvailableBusesWithClient } from "../shared/busAvailabilityQuery.js";
export { normalizeSeatCount, searchAvailableBusesFromData } from "../shared/busAvailabilityCore.js";

export async function searchAvailableBuses(options) {
  if (!options.companyId) throw new Error("companyId is required");
  return searchAvailableBusesWithClient(supabase, options);
}
